import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemChocolate = function IconSystemChocolate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "m7.61 16.295 4.342-4.343m-4.343 4.343-3.082-3.083m3.082 3.083-.565.565a1 1 0 0 0 0 1.414l1.458 1.459a1 1 0 0 0 1.69-.53l.05-.275m1.71-6.976 4.342-4.342m-4.342 4.342L8.869 8.87m7.425-1.26-3.082-3.083m3.082 3.083.566-.566a1 1 0 0 1 1.414 0l1.458 1.458a1 1 0 0 1-.528 1.69l-.277.051M5.787 5.787 2.15 9.423a1 1 0 0 0 0 1.414l2.376 2.375m1.26-7.425 3.635-3.635a1 1 0 0 1 1.414 0l2.376 2.375m-7.425 1.26L8.869 8.87m-4.342 4.342L8.869 8.87m0 0 4.343-4.343m-2.97 14.401.361-1.988a1 1 0 0 1 .707-.782l3.233-.93a1 1 0 0 0 .684-.685l.93-3.232a1 1 0 0 1 .783-.707l1.987-.361m-8.684 8.685 2.92 2.921a1 1 0 0 0 1.415 0l7.27-7.27a1 1 0 0 0 0-1.415l-2.92-2.921"
  }));
};